// extracted by mini-css-extract-plugin
export default {"gridContainer":"CardsGrid_gridContainer__VNueU","gridItem":"CardsGrid_gridItem__0nqG7","takeOneThird":"CardsGrid_takeOneThird__yPyYe","takeHalf":"CardsGrid_takeHalf__2gmTo"};